
<template>
  <div class="editFood">

    <div class="addImage">



<transition name="fade">
  <img class="newimage" v-if="newimage" :src="newimage" />
  <img class="currentImage" v-else :src="food.image" />
</transition>


      <div class="images">


        <img class="image" @click="newimage === imgUrl(food.knownAs)"
          :src="'https://spoonacular.com/cdn/ingredients_500x500/' + food.knownAs + '.jpg'" />

       <template v-if=(/\s/.test(food.name))>
        <img class="image" v-if="food.knownAs" :src="'https://spoonacular.com/cdn/ingredients_500x500/' + food.KnownAs.replace(' ', '-') + '.jpg'" />
 
        <img class="image" :src="'https://spoonacular.com/cdn/ingredients_500x500/' + food.name.replace(' ', '-') + '.jpg'" />
       </template>   

        <img class="image" :src="'https://spoonacular.com/cdn/ingredients_500x500/' + food.name + '.jpg'" />
  
      </div>

      <div class='file-input button'>
        <input type='file' @change="fileSelected">
        <svg fill="none" height="38" viewBox="0 0 24 24" width="38" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.9984 6.24971C20.9984 4.45495 19.5435 3 17.7487 3H6.24971C4.45495 3 3 4.45495 3 6.24971V17.7487C3 19.5435 4.45495 20.9984 6.24971 20.9984H11.1644L11.5202 19.5754C11.5266 19.5497 11.5333 19.5241 11.5402 19.4985H6.24971C6.04586 19.4985 5.85015 19.4637 5.66822 19.3996L11.4745 13.7138L11.558 13.6431C11.8493 13.4307 12.2588 13.4543 12.5238 13.7139L14.6028 15.7501L15.6636 14.6893L13.5732 12.6423L13.4448 12.5257C12.5666 11.7877 11.2581 11.8265 10.4251 12.6421L4.60312 18.3423C4.53629 18.157 4.49987 17.9571 4.49987 17.7487V6.24971C4.49987 5.2833 5.2833 4.49987 6.24971 4.49987H17.7487C18.7151 4.49987 19.4985 5.2833 19.4985 6.24971V11.2317C19.9774 11.0412 20.492 10.9678 20.9984 11.0115V6.24971ZM17.503 8.75161C17.503 7.50791 16.4947 6.49969 15.251 6.49969C14.0073 6.49969 12.9991 7.50791 12.9991 8.75161C12.9991 9.99531 14.0073 11.0035 15.251 11.0035C16.4947 11.0035 17.503 9.99531 17.503 8.75161ZM14.499 8.75161C14.499 8.33626 14.8357 7.99956 15.251 7.99956C15.6664 7.99956 16.0031 8.33626 16.0031 8.75161C16.0031 9.16695 15.6664 9.50366 15.251 9.50366C14.8357 9.50366 14.499 9.16695 14.499 8.75161ZM19.0984 12.6686L13.1965 18.5705C12.8524 18.9146 12.6083 19.3458 12.4903 19.8179L12.0327 21.6484C11.8336 22.4445 12.5547 23.1656 13.3508 22.9666L15.1813 22.5089C15.6534 22.3909 16.0846 22.1468 16.4287 21.8027L22.3306 15.9008C23.2231 15.0082 23.2231 13.5611 22.3306 12.6686C21.4381 11.7761 19.991 11.7761 19.0984 12.6686Z"
            fill="currentColor" />
        </svg>
        <!-- <span class='label' data-js-label>No file selected</span> -->
      </div>

    </div>


    <div class="inputList">

      <div class="input Name">
        <label>Name</label>
        <input type="text" :placeholder="food.name" v-model="food.name" />
      </div>

      <div class="input Category">
        <label>Category</label>
        <input type="text" :placeholder="'Category'" v-model="food.category" />
      </div>

      <div class="input CaloriesPer100g">
        <label>Calories per 100g</label>
        <input type="text" :placeholder="food.caloriesPer100g" v-model="food.caloriesPer100g" />
      </div>

      <div class="input brand">
        <label>Brand</label>
        <input type="text" :placeholder="food.brand" v-model="food.brand" />
      </div>




    </div>



    <div class="buttons">
      <button class="save-btn button" @click="updateFood(updatedFood)">Save</button>
      <button class="delete-btn button" @click="deleteFood(food)">Delete</button>

    </div>
  </div>
</template>

<script>
export default {
  name: 'EditFood',
  created() {

  },
  data() {
    return {
      newimage: null
    }
  },
  props: {
    food: Object
  },
  computed: {
    // a computed getter
    updatedFood() {
      console.log(this.food)

      let f = {
        ...this.food,
        image: this.newimage ? this.newimage : this.food.image
      }
      console.log(f)
      return f
    }
  },
  methods: {
    imgUrl(img) {
      let url = 'https://spoonacular.com/cdn/ingredients_500x500/' + img + '.jpg'
      const getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        console.log(data)
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
          }
        });
      }
      getBase64FromUrl(url).then((image) => {
        this.newimage = image;
      });


    },
    fileSelected(event) {
      const file = event.target.files.item(0);
      const reader = new FileReader();
      reader.addEventListener('load', this.imageLoader);
      reader.readAsDataURL(file);
    },
    imageLoader(event) {

      this.newimage = event.target.result;
      //console.log(this.food.image)
    }
  },
}
</script>

<style lang="scss" scoped>
.file-input [type="file"] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 10;
  cursor: pointer;
}

.addImage {
  position: relative;
  /* border: 1px solid red; */
  display: flex;
  justify-content: center;
 // background: var(--gray-50);
  margin-bottom: 12px;
  flex-direction: column-reverse;
  flex-direction: column;
    align-items: center;
    gap: 16px;
}

.images {
  display: flex;
  gap: 12px;
}
.newimage, .currentImage {
    border-radius: 24px;
    width:300px;
}

img.image {
  border-radius: 18px;
    /* width: 100px; */
    width: 102px;
    /* border: 1px solid var(--gray-200); */
    padding: 10px;
    background: white;
    object-fit: contain;
    box-shadow: -1px 5px 30px -3px #bcbcbc36;
  
}

.file-input.button {
  position: absolute;
  /* top: 0em; */
  /* right: 0; */
  bottom: 6.6em;
    left: 17em;
  color: #ffffff99;
  filter: drop-shadow(0px 20px 20px #5656659c);
  backdrop-filter: blur(4px);
  /* width: 200px; */
  height: fit-content;
  width: fit-content;
  border-radius: 12px;
  overflow: auto;
  background: #ffffff40;
  display: flex;
}




.inputList {
  display: flex;
  gap: 8px;
  flex-direction: column;
}

.input {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  flex-direction: column;
}



input[type="text"] {
  padding: 8px;
  font-family: Poppins;
  border-radius: 8px;
  background: var(--input-bg);
  color: var(--input-text);
  width: -webkit-fill-available;
  border: 1px solid #c2c2c27a;
  /* border: none; */
  /* background: #dddddd24; */
  width: -webkit-fill-available;
  color: #57585ebf;
  width: -webkit-fit-content;
  width: 100%;
  color: var(--gray-500)
    /* width: unset; */
}

::placeholder {
  color: var(--gray-400);
  opacity: 1;
}



input[type="text"] {
  border-radius: 1em;
  border: none;
  padding: 12px 12px;
  border: 1px solid var(--gray-200);
  display: flex;
  flex-direction: column;
  /* text-align: center; */
}

label {
  font-weight: 500;
  font-size: 13px;
  color: var(--gray-400);
}




.buttons {
    display: flex;
    gap: 8px;
    padding: 12px 0px;

    .button {
  background: var(--gray-700);
  border: none;
  padding: 12px 12px;
  border-radius: 12px;
  font-size: 12px;
  color: var(--gray-50);
}
}
</style>

